import React from 'react';
import { useNavigate } from 'react-router-dom';
import ClassGate from './ClassGate';

const RESOURCES = [
  {
    icon: 'bi-easel2',
    label: 'Presentación',
    description: 'Diapositivas del curso (Reveal.js)',
    action: () => window.open('/classes/tda-ml/slides.html', '_blank'),
    available: true,
  },
  {
    icon: 'bi-code-square',
    label: 'Demo interactivo',
    description: 'Notebook de Python con ejemplos en vivo',
    action: null,
    available: false,
  },
  {
    icon: 'bi-chat-dots',
    label: 'Chat del curso',
    description: 'Asistente RAG con el material del curso',
    action: null,
    available: false,
  },
];

export default function ClassTdaMl() {
  const navigate = useNavigate();

  return (
    <ClassGate classId="tda-ml" className="Análisis Topológico de Datos">
    <div>
      <button
        onClick={() => navigate('/classes')}
        style={{
          background: 'none',
          border: 'none',
          color: 'var(--text-muted)',
          cursor: 'pointer',
          padding: '0 0 1.25rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          fontSize: '0.875rem',
        }}
      >
        <i className="bi bi-arrow-left" /> Todas las clases
      </button>

      <div style={{ marginBottom: '2rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
          <span style={{
            background: 'var(--accent-dim)',
            color: 'var(--accent)',
            fontSize: '0.75rem',
            fontWeight: 700,
            padding: '0.2rem 0.6rem',
            borderRadius: 6,
            letterSpacing: '0.04em',
          }}>
            MCD524
          </span>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>INTEC · 2026</span>
        </div>
        <h1 style={{ fontSize: '1.6rem', fontWeight: 700, lineHeight: 1.3, marginBottom: '0.6rem' }}>
          Análisis Topológico de Datos<br />para Mercados Financieros
        </h1>
        <p style={{ color: 'var(--text-muted)', maxWidth: 620, lineHeight: 1.6 }}>
          Este curso presenta los fundamentos de la topología algebraica y su aplicación al análisis
          de series de tiempo financieras, incluyendo homología persistente, diagramas de persistencia,
          y la estimación del exponente de Hurst mediante TDA.
        </p>
      </div>

      <h2 style={{ fontSize: '1rem', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '1rem' }}>
        Recursos
      </h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '1rem' }}>
        {RESOURCES.map((r) => (
          <div
            key={r.label}
            onClick={r.available ? r.action : undefined}
            style={{
              background: 'var(--bg-card)',
              border: `1px solid ${r.available ? 'var(--border)' : 'var(--border)'}`,
              borderRadius: 'var(--radius)',
              padding: '1.25rem 1.5rem',
              cursor: r.available ? 'pointer' : 'default',
              opacity: r.available ? 1 : 0.45,
              transition: 'border-color 0.15s, background 0.15s',
              display: 'flex',
              alignItems: 'flex-start',
              gap: '1rem',
            }}
            onMouseEnter={e => { if (r.available) { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.background = 'var(--bg-hover)'; } }}
            onMouseLeave={e => { if (r.available) { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.background = 'var(--bg-card)'; } }}
          >
            <i className={`bi ${r.icon}`} style={{ fontSize: '1.4rem', color: r.available ? 'var(--accent)' : 'var(--text-muted)', marginTop: 2 }} />
            <div>
              <div style={{ fontWeight: 600, marginBottom: '0.2rem' }}>
                {r.label}
                {!r.available && <span style={{ fontSize: '0.7rem', marginLeft: '0.5rem', color: 'var(--text-muted)' }}>próximamente</span>}
              </div>
              <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)' }}>{r.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
    </ClassGate>
  );
}
